module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand12-14fd54714a79d19b76d39d5c628a4f40.jpg";